import type {
  NavigationLinks,
  NavigationModelLinks,
} from "./navigation-link.type";

import {
  CloudUploadOutlined,
  DashboardOutlined,
  LockOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
} from "@ant-design/icons";

import { TAB_KEYS } from "@/constants/TabKeys";
import { HELP_CENTER_URL } from "@/modules/help-center";
import ModelIcon from "@/modules/model-icon";
import { IconCustom } from "@/ui/icon-custom";

export const NAVIGATION_LINKS: NavigationLinks = {
  dashboard: {
    routeKey: "dashboard",
    icon: <DashboardOutlined />,
  },
  import: {
    routeKey: "import",
    icon: <CloudUploadOutlined />,
    featureFlag: "dev34",
  },
  language: {
    routeKey: "preferences",
    search: `?tab=${TAB_KEYS.PREFERENCES_GENERAL}`,
    icon: <IconCustom type="language" />,
  },
  mySpace: {
    routeKey: "my_space",
    icon: <ModelIcon model="intervention" />,
  },
  password: {
    routeKey: "preferences",
    search: `?tab=${TAB_KEYS.PREFERENCES_PASSWORD}`,
    icon: <LockOutlined />,
  },
  preferences: {
    routeKey: "preferences",
    icon: <SettingOutlined />,
  },
  support: {
    url: HELP_CENTER_URL,
    icon: <QuestionCircleOutlined />,
    external: true,
  },
};

export const NAVIGATION_MODEL_LINKS: NavigationModelLinks = {
  activities: {
    modelKey: "activity",
    authorization: "view",
  },
  assets: {
    modelKey: "asset",
    authorization: null,
  },
  assetTypes: {
    modelKey: "assettype",
    authorization: "create",
  },
  interventions: {
    modelKey: "intervention",
    authorization: null,
  },
  interventionTemplates: {
    modelKey: "interventiontemplate",
    authorization: "create",
  },
  locations: {
    modelKey: "location",
    authorization: "view",
  },
  observations: {
    modelKey: "observation",
    authorization: null,
  },
  organizations: {
    modelKey: "organization",
    authorization: "update",
  },
  projects: {
    modelKey: "project",
    authorization: "view",
  },
  technicalForms: {
    modelKey: "technicalform",
    authorization: "create",
  },
  users: {
    modelKey: "user",
    authorization: "view",
  },
};
